module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "collumns"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('img', {
    attrs: {
      "width": "125px",
      "src": require("../assets/img/javascript.png")
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_vm._v("JavaScript")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_vm._v("\n                My journey with JavaScript commenced in 2017. \n                This incredibly versatile language has opened doors across various domains, from front-end and back-end development. \n                Its adaptability knows no bounds.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('img', {
    attrs: {
      "width": "125px",
      "src": require("../assets/img/typescript.svg")
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_vm._v("TypeScript")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_vm._v("\n                Since 2020, I've been actively utilizing TypeScript, a remarkable superset of JavaScript. \n                Its incorporation has proven to be transformative. By empowering us to implement type-enforced solutions,\n                TypeScript becomes a pivotal tool in our pursuit of delivering top-notch, high-quality outcomes.\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('img', {
    attrs: {
      "width": "200px",
      "src": require("../assets/img/nodejs.png")
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_vm._v("NodeJS")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_vm._v("\n                Since 2017, I've been deeply engaged with NodeJS an exceptional selection for backend development. \n                JavaScript's prowess on this front is undeniable. \n                Leveraging the NPM package manager further enriches our capabilities, offering an extensive array of libraries to streamline our development process.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('img', {
    attrs: {
      "width": "125px",
      "src": require("../assets/img/nest.svg")
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_vm._v("NestJS")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_vm._v("\n                Since 2020, I've immersed myself in NestJS an exceptional JavaScript/TypeScript framework. \n                This dynamic framework is a powerhouse, equipped with an array of tools and seamless integrations. \n                Notably, its foundation on the Angular architecture solidifies its robustness, further enhancing its capabilities.\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('img', {
    attrs: {
      "width": "200px",
      "src": require("../assets/img/mysql.png")
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_vm._v("MySQL")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_vm._v("\n                I engage with MySQL in various projects. \n                This open-source relational database engine stands out for its reliability and speed. Whenever the need arises for transactions, \n                MySQL is my go-to choice due to its robust performance.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('img', {
    attrs: {
      "width": "100px",
      "src": require("../assets/img/mongodb.png")
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_vm._v("MongoDB")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_vm._v("\n                MongoDB stands as an exceptional NoSQL engine in my toolkit. I readily turn to it when seeking rapid response times. \n                Boasting a document-based structure akin to JSON (BSON), MongoDB seamlessly aligns speed with flexibility in my projects.\n              ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221696c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-g-network.vue
// module id = 415
// module chunks = 1